(() => {
  var o, e;
  ((o = 'active'),
    (e = document.querySelectorAll('.qa-dropdown__content > .dropdown-box')) &&
      e.forEach(function (e) {
        e.addEventListener(
          'click',
          (function (e) {
            return function (n) {
              var t = {
                drawer: e.querySelector('.dropdown-box__question'),
                content: e.querySelector('.dropdown-box__answer'),
              };
              (t.drawer.classList.toggle(o), t.content.classList.toggle(o));
            };
          })(e),
        );
      }));
})();
//# sourceMappingURL=qa-dropdown.js.map
